import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';
import { theme } from '../../layout/theme';

export const StyledMain = styled.div`
  position: sticky;
  top: 0;
  z-index: ${theme.layers.header};

  ${theme.screens.LtMd} {
    padding-bottom: ${size(7)};

    &:before {
      content: '';
      background-color: ${theme.colors.bg.main};
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      bottom: ${size(7)};
    }
  }

  ${theme.screens.Md} {
    padding: ${size(3)} 0;
    background-color: ${theme.colors.bg.main};
  }
`;

export const Inner = styled.div`
  display: flex;

  ${theme.screens.LtMd} {
    position: relative;
    flex-wrap: wrap;
  }

  ${theme.screens.Md} {
    align-items: center;
  }
`;

// Decides upper part height on smaller screens
export const UpperMobile = styled.div`
  ${theme.screens.LtMd} {
    height: ${size(7)};
  }

  ${theme.screens.Md} {
    display: none;
  }
`;

export const ActionSection = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;

  &.is-right {
    margin-left: auto;

    ${theme.screens.Md} {
      padding-left: ${size(3)};
    }
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: ${size(-1)};
`;

const actionCss = css`
  position: relative;
  display: flex;
  align-items: center;
  padding: ${size(1)};
  transform-origin: 50% 50%;
  transition:
    transform 200ms ease,
    opacity 200ms ease;

  &:active {
    transform: scale(0.95);
  }

  &.is-positive {
    color: ${theme.colors.ui.positive};
  }

  &.is-hidden {
    opacity: 0;
    pointer-events: none;
    cursor: default;
  }
`;

export const Action = styled.button`
  ${actionCss}
`;

export const ActionLink = styled.a`
  ${actionCss}
`;

export const ActionIcon = styled.span`
  position: relative;
  display: block;
  flex-shrink: 0;

  ${theme.screens.Md} {
    font-size: ${size(3)};

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: ${size(6)};
      height: ${size(6)};
      transform: translate(-50%, -50%);
      background-color: ${theme.colors.bg.accent};
      border-radius: 50%;
      z-index: -1;
      opacity: 0;
    }

    ${Action}:hover &,
    ${ActionLink}:hover & {
      &:before {
        opacity: 1;
      }
    }
  }

  .menu-icon {
    font-size: 32px;
  }

  .search-icon {
    font-size: 22px;
    margin-right: ${size(1)};
  }

  .cart-icon {
    font-size: 24px;
  }
`;

export const ActionText = styled.span`
  display: block;
  font-size: 0.875rem;
  margin-left: ${size(1)};
`;

export const ActionBadge = styled.span`
  position: absolute;
  top: ${size(1)};
  right: ${size(1)};
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(50%, -50%);
  height: ${size(2.5)};
  min-width: ${size(2.5)};
  background-color: ${theme.colors.bg.alt};
  color: ${theme.colors.text.onColor};
  border-radius: ${size(1.25)};
  font-size: 0.75rem;
  font-weight: 600;

  &.extra-padding {
    padding: 0 ${size(0.5)};
  }
`;

export const LogoSection = styled.div`
  ${theme.screens.LtMd} {
    position: absolute;
    top: ${size(1.5)};
    left: 50%;
    transform: translateX(-50%);
  }

  ${theme.screens.Md} {
    flex-shrink: 0;
    padding: 0 ${size(6.5)};
    top: ${size(2)};
  }
`;

export const Logo = styled.svg`
  display: block;
  height: ${size(6)};
  fill: currentColor;

  ${theme.screens.LtMd} {
    height: ${size(4)};
  }
`;

export const Search = styled.div`
  flex: 1 1 auto;

  ${theme.screens.LtMd} {
    order: 4;
    display: flex;
    align-items: center;
    width: 100%;
    height: ${size(7)};
    transition: 200ms ease;
    position: absolute;
    z-index: -1;
    top: ${size(7)};
    left: 0;
    background-color: ${theme.colors.bg.main};
    padding: 0 ${size(2)};
    bottom: 0;
    left: ${size(-2)};
    right: ${size(-2)};
    width: auto;

    &.is-hidden {
      margin-top: ${size(-7)};
    }
  }
`;

export const SearchBar = styled.div`
  ${theme.screens.LtMd} {
    flex: 1 1 auto;
  }
`;
